/* this file is auto-generated by build-color-list.ts, do not edit manually */

/**
 * a list of Tailwind CSS colors converted to RGB format.
 */
export const twColors = {
  black: "0, 0, 0",
  white: "255, 255, 255",
  slate_50: "248, 250, 252",
  slate_100: "241, 245, 249",
  slate_200: "226, 232, 240",
  slate_300: "202, 213, 226",
  slate_400: "144, 161, 185",
  slate_500: "98, 116, 142",
  slate_600: "69, 85, 108",
  slate_700: "49, 65, 88",
  slate_800: "29, 41, 61",
  slate_900: "15, 23, 43",
  slate_950: "2, 6, 24",
  gray_50: "249, 250, 251",
  gray_100: "243, 244, 246",
  gray_200: "229, 231, 235",
  gray_300: "209, 213, 220",
  gray_400: "153, 161, 175",
  gray_500: "106, 114, 130",
  gray_600: "74, 85, 101",
  gray_700: "54, 65, 83",
  gray_800: "30, 41, 57",
  gray_900: "16, 24, 40",
  gray_950: "3, 7, 18",
  zinc_50: "250, 250, 250",
  zinc_100: "244, 244, 245",
  zinc_200: "228, 228, 231",
  zinc_300: "212, 212, 216",
  zinc_400: "159, 159, 169",
  zinc_500: "113, 113, 123",
  zinc_600: "82, 82, 92",
  zinc_700: "63, 63, 71",
  zinc_800: "39, 39, 42",
  zinc_900: "24, 24, 27",
  zinc_950: "9, 9, 11",
  neutral_50: "250, 250, 250",
  neutral_100: "245, 245, 245",
  neutral_200: "229, 229, 229",
  neutral_300: "212, 212, 212",
  neutral_400: "161, 161, 161",
  neutral_500: "115, 115, 115",
  neutral_600: "82, 82, 82",
  neutral_700: "64, 64, 64",
  neutral_800: "38, 38, 38",
  neutral_900: "23, 23, 23",
  neutral_950: "10, 10, 10",
  stone_50: "250, 250, 249",
  stone_100: "245, 245, 244",
  stone_200: "231, 229, 228",
  stone_300: "214, 211, 209",
  stone_400: "166, 160, 155",
  stone_500: "121, 113, 107",
  stone_600: "87, 83, 77",
  stone_700: "68, 64, 59",
  stone_800: "41, 37, 36",
  stone_900: "28, 25, 23",
  stone_950: "12, 10, 9",
  mauve_50: "250, 250, 250",
  mauve_100: "243, 241, 243",
  mauve_200: "231, 228, 231",
  mauve_300: "215, 208, 215",
  mauve_400: "168, 158, 169",
  mauve_500: "121, 105, 123",
  mauve_600: "89, 76, 91",
  mauve_700: "70, 57, 71",
  mauve_800: "42, 33, 44",
  mauve_900: "29, 22, 30",
  mauve_950: "12, 9, 12",
  olive_50: "251, 251, 249",
  olive_100: "244, 244, 240",
  olive_200: "232, 232, 227",
  olive_300: "216, 216, 208",
  olive_400: "171, 171, 156",
  olive_500: "124, 124, 103",
  olive_600: "91, 91, 75",
  olive_700: "71, 71, 57",
  olive_800: "43, 43, 34",
  olive_900: "29, 29, 22",
  olive_950: "12, 12, 9",
  mist_50: "249, 251, 251",
  mist_100: "241, 243, 243",
  mist_200: "227, 231, 232",
  mist_300: "208, 214, 216",
  mist_400: "156, 168, 171",
  mist_500: "103, 120, 124",
  mist_600: "75, 88, 91",
  mist_700: "57, 68, 71",
  mist_800: "34, 41, 43",
  mist_900: "22, 27, 29",
  mist_950: "9, 11, 12",
  taupe_50: "251, 250, 249",
  taupe_100: "243, 241, 241",
  taupe_200: "232, 228, 227",
  taupe_300: "216, 210, 208",
  taupe_400: "171, 160, 156",
  taupe_500: "124, 109, 103",
  taupe_600: "91, 79, 75",
  taupe_700: "71, 60, 57",
  taupe_800: "43, 36, 34",
  taupe_900: "29, 24, 22",
  taupe_950: "12, 10, 9",
  red_50: "254, 242, 242",
  red_100: "255, 226, 226",
  red_200: "255, 201, 201",
  red_300: "255, 162, 162",
  red_400: "255, 100, 103",
  red_500: "251, 44, 54",
  red_600: "231, 0, 11",
  red_700: "193, 0, 7",
  red_800: "159, 7, 18",
  red_900: "130, 24, 26",
  red_950: "70, 8, 9",
  orange_50: "255, 247, 237",
  orange_100: "255, 237, 212",
  orange_200: "255, 214, 168",
  orange_300: "255, 184, 106",
  orange_400: "255, 137, 4",
  orange_500: "255, 105, 0",
  orange_600: "245, 73, 0",
  orange_700: "202, 53, 0",
  orange_800: "159, 45, 0",
  orange_900: "126, 42, 12",
  orange_950: "68, 19, 6",
  amber_50: "255, 251, 235",
  amber_100: "254, 243, 198",
  amber_200: "254, 230, 133",
  amber_300: "255, 210, 48",
  amber_400: "255, 185, 0",
  amber_500: "254, 154, 0",
  amber_600: "225, 113, 0",
  amber_700: "187, 77, 0",
  amber_800: "151, 60, 0",
  amber_900: "123, 51, 6",
  amber_950: "70, 25, 1",
  yellow_50: "254, 252, 232",
  yellow_100: "254, 249, 194",
  yellow_200: "255, 240, 133",
  yellow_300: "255, 223, 32",
  yellow_400: "253, 199, 0",
  yellow_500: "240, 177, 0",
  yellow_600: "208, 135, 0",
  yellow_700: "166, 95, 0",
  yellow_800: "137, 75, 0",
  yellow_900: "115, 62, 10",
  yellow_950: "67, 32, 4",
  lime_50: "247, 254, 231",
  lime_100: "236, 252, 202",
  lime_200: "216, 249, 153",
  lime_300: "187, 244, 81",
  lime_400: "154, 230, 0",
  lime_500: "124, 207, 0",
  lime_600: "94, 165, 0",
  lime_700: "73, 125, 0",
  lime_800: "60, 99, 0",
  lime_900: "53, 83, 14",
  lime_950: "25, 46, 3",
  green_50: "240, 253, 244",
  green_100: "220, 252, 231",
  green_200: "185, 248, 207",
  green_300: "123, 241, 168",
  green_400: "5, 223, 114",
  green_500: "0, 201, 80",
  green_600: "0, 166, 62",
  green_700: "0, 130, 54",
  green_800: "1, 102, 48",
  green_900: "13, 84, 43",
  green_950: "3, 46, 21",
  emerald_50: "236, 253, 245",
  emerald_100: "208, 250, 229",
  emerald_200: "164, 244, 207",
  emerald_300: "94, 233, 181",
  emerald_400: "0, 212, 146",
  emerald_500: "0, 188, 125",
  emerald_600: "0, 153, 102",
  emerald_700: "0, 122, 85",
  emerald_800: "0, 96, 69",
  emerald_900: "0, 79, 59",
  emerald_950: "0, 44, 34",
  teal_50: "240, 253, 250",
  teal_100: "203, 251, 241",
  teal_200: "150, 247, 228",
  teal_300: "70, 236, 213",
  teal_400: "0, 213, 190",
  teal_500: "0, 187, 167",
  teal_600: "0, 150, 137",
  teal_700: "0, 120, 111",
  teal_800: "0, 95, 90",
  teal_900: "11, 79, 74",
  teal_950: "2, 47, 46",
  cyan_50: "236, 254, 255",
  cyan_100: "206, 250, 254",
  cyan_200: "162, 244, 253",
  cyan_300: "83, 234, 253",
  cyan_400: "0, 211, 243",
  cyan_500: "0, 184, 219",
  cyan_600: "0, 146, 184",
  cyan_700: "0, 117, 149",
  cyan_800: "0, 95, 120",
  cyan_900: "16, 78, 100",
  cyan_950: "5, 51, 69",
  sky_50: "240, 249, 255",
  sky_100: "223, 242, 254",
  sky_200: "184, 230, 254",
  sky_300: "116, 212, 255",
  sky_400: "0, 188, 255",
  sky_500: "0, 166, 244",
  sky_600: "0, 132, 209",
  sky_700: "0, 105, 168",
  sky_800: "0, 89, 138",
  sky_900: "2, 74, 112",
  sky_950: "5, 47, 74",
  blue_50: "239, 246, 255",
  blue_100: "219, 234, 254",
  blue_200: "190, 219, 255",
  blue_300: "142, 197, 255",
  blue_400: "81, 162, 255",
  blue_500: "43, 127, 255",
  blue_600: "21, 93, 252",
  blue_700: "20, 71, 230",
  blue_800: "25, 60, 184",
  blue_900: "28, 57, 142",
  blue_950: "22, 36, 86",
  indigo_50: "238, 242, 255",
  indigo_100: "224, 231, 255",
  indigo_200: "198, 210, 255",
  indigo_300: "163, 179, 255",
  indigo_400: "124, 134, 255",
  indigo_500: "97, 95, 255",
  indigo_600: "79, 57, 246",
  indigo_700: "67, 45, 215",
  indigo_800: "55, 42, 172",
  indigo_900: "49, 44, 133",
  indigo_950: "30, 26, 77",
  violet_50: "245, 243, 255",
  violet_100: "237, 233, 254",
  violet_200: "221, 214, 255",
  violet_300: "196, 180, 255",
  violet_400: "166, 132, 255",
  violet_500: "142, 81, 255",
  violet_600: "127, 34, 254",
  violet_700: "112, 8, 231",
  violet_800: "93, 14, 192",
  violet_900: "77, 23, 154",
  violet_950: "47, 13, 104",
  purple_50: "250, 245, 255",
  purple_100: "243, 232, 255",
  purple_200: "233, 212, 255",
  purple_300: "218, 178, 255",
  purple_400: "194, 122, 255",
  purple_500: "173, 70, 255",
  purple_600: "152, 16, 250",
  purple_700: "130, 0, 219",
  purple_800: "110, 17, 176",
  purple_900: "89, 22, 139",
  purple_950: "60, 3, 102",
  fuchsia_50: "253, 244, 255",
  fuchsia_100: "250, 232, 255",
  fuchsia_200: "246, 207, 255",
  fuchsia_300: "244, 168, 255",
  fuchsia_400: "237, 106, 255",
  fuchsia_500: "225, 42, 251",
  fuchsia_600: "200, 0, 222",
  fuchsia_700: "168, 0, 183",
  fuchsia_800: "138, 1, 148",
  fuchsia_900: "114, 19, 120",
  fuchsia_950: "75, 0, 79",
  pink_50: "253, 242, 248",
  pink_100: "252, 231, 243",
  pink_200: "252, 206, 232",
  pink_300: "253, 165, 213",
  pink_400: "251, 100, 182",
  pink_500: "246, 51, 154",
  pink_600: "230, 0, 118",
  pink_700: "198, 0, 92",
  pink_800: "163, 0, 76",
  pink_900: "134, 16, 67",
  pink_950: "81, 4, 36",
  rose_50: "255, 241, 242",
  rose_100: "255, 228, 230",
  rose_200: "255, 204, 211",
  rose_300: "255, 161, 173",
  rose_400: "255, 99, 126",
  rose_500: "255, 32, 86",
  rose_600: "236, 0, 63",
  rose_700: "199, 0, 54",
  rose_800: "165, 0, 54",
  rose_900: "139, 8, 54",
  rose_950: "77, 2, 24",
} as const;
